<!-- <img src="assets/images/background.png" class="Background"> -->
<div class="parent">
  <!-- SIDE BAR -->
  <div class="deviceDetails">

    <div class="sidebar-top">
      <div class="cliqtest-logo"></div>
    </div>

    <div class="sidebar-middle">
      <button (click)="key('home')" title="Home" class="navbarbuttons" aria-label="Home">
        <!-- <img class="icons" src="assets/NavButtons/home.png" /> -->
        <!-- <i class="fa fa-home icons" aria-hidden="true"></i> -->
        <i class="fa-solid fa-house icons"></i>
      </button>

      @if (!device?.ios) {
        <button (click)="key('app_switch')" title="Recent Apps" class="navbarbuttons">
          <!-- <img class="icons" src="assets/NavButtons/app.png" /> -->
          <i class="bi bi-distribute-horizontal icons" aria-hidden="true"></i>
        </button>
      }

      <button (click)="press('power')" title="Lock" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/Lock.png" /> -->
        <i class="fa fa-lock icons" aria-hidden="true"></i>
      </button>


      @if (!device?.ios) {
        <button (click)="press('menu')" title="Unlock" class="navbarbuttons">
          <!-- <img class="icons" src="assets/NavButtons/Unlock.png" /> -->
          <i class="fa fa-unlock-alt icons" aria-hidden="true"></i>
        </button>
      }
      <button (click)="appInstall()" title="apk install" style="height: 50px; max-height: 50px; display: block; filter: invert(100%);"
        class="navbarbuttons"><img class="icons" src="assets/NavButtons/install.png">
      </button>
      <button (click)="takeScreenShot()"
        title="screen shoot"
        style="height: 50px; max-height: 50px; display: block; filter: invert(100%);" class="navbarbuttons"><img
        class="icons" src="assets/NavButtons/capture.png">
      </button>


      <button (click)="openSettings()" title="Settings" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/settings.png" /> -->
        <i class="fa fa-cog icons" aria-hidden="true"></i>
      </button>

      <button (click)="openScreenRecord()" title="screen record" style="height: 50px; max-height: 50px; display: block; filter: invert(100%);"
        class="navbarbuttons"><img class="icons" src="assets/NavButtons/monitor-screen.png">
      </button>

      @if (!device?.ios) {
        <button (click)="$event.stopPropagation(); toggleThrottleOptions()" title="Throttle Network"
          class="navbarbuttons">
          <i class="fa fa-signal icons" aria-hidden="true"></i>
        </button>
      }

      @if (showThrottleOptions) {
        <div class="throttle-dropdown-wrapper">
          <div class="throttle-arrow"></div>
          <div class="throttle-dropdown">
            @for (opt of throttleOptions; track opt) {
              <button (click)="applyThrottle(opt)"
                class="throttle-option-btn">
                {{ opt.label }}
              </button>
            }
          </div>
        </div>
      }

      <button (click)="aboutDeviceToggle()" title="About Device" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/info.png" /> -->
        <i class="fa fa-info-circle icons" aria-hidden="true"></i>
      </button>

      <button onclick="history.back()" title="Minimize the full-view" style="margin-top: 20px;"
        class="navbarbuttons">
        <i class="fa-solid fa-compress icons"></i>
      </button>
    </div>
  </div>
  <!-- parent device -->
  <div class="mobileScreen">
    <div class="positioner master-device">
      @if (loader) {
        <div [ngStyle]="{'cursor':cursor,'aspect-ratio':canvasAspect}" class="mainDivLoader">
                <span [ngClass]="{'bi bi-android android': device?.platform == 'Android',
                                 'bi bi-apple iOS': device?.platform == 'iOS'}">
          </span>
          <label class="loadbar" [ngStyle]="{'top': getTopPosition(device)}">
            <span class="sr-only"></span>
            <progress class="progressBar"></progress>
          </label>
        </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas class="screen"></canvas>
      <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
        focus-element="$root.screenFocus" />


    </div>
    <div class="device-header parent-device">{{this.device?.model}}</div>
  </div>
  <div class="slave-container" [ngStyle]="{'display':deviceCount!=5?'flex':'none'}">
    <!-- 1st slave device -->
    <div [ngStyle]="{'display':deviceCount!=5?'flex':'none','height':(deviceCount==3 || deviceCount==2)?'75vh':'65vh'}"
      class="mobileScreenSlaves">
      <div class="positioner">
        @if (loader1) {
          <div
            [ngStyle]="{'cursor':cursor1,'aspect-ratio':canvasAspect1,'left':(deviceCount>=2 && deviceCount<=3)?'40px':'25px'}"
            class="mainDivLoader">
                    <span [ngClass]="{'bi bi-android android': device1?.platform == 'Android',
                                 'bi bi-apple iOS': device2?.platform == 'iOS'}"></span>
            <label class="loadbar" [ngStyle]="{'top': getTopPosition(device1)}">
              <span class="sr-only"></span>
              <progress class="progressBar"></progress>
            </label>
          </div>
        }
        <img [ngStyle]="{'aspect-ratio':canvasAspect1}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png"
          alt="Mobile wrapper">
        <canvas class="screen"></canvas>
        <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
      </div>
      <div class="device-header parent-device">{{device1?.model}}</div>
    </div>
    <!-- 2nd slave device -->
    <div [ngStyle]="{'display':deviceCount!=5 && deviceCount>=3?'flex':'none','height':deviceCount==3?'75vh':'65vh'}"
      class="mobileScreenSlaves">
      <div class="positioner">
        @if (loader2) {
          <div
            [ngStyle]="{'cursor':cursor2,'aspect-ratio':canvasAspect2,'left':(deviceCount>=2 && deviceCount<=3)?'40px':'25px'}"
            class="mainDivLoader">
                    <span [ngClass]="{'bi bi-android android': device2?.platform == 'Android',
                                 'bi bi-apple iOS': device2?.platform == 'iOS'}"></span>
            <label class="loadbar" [ngStyle]="{'top': getTopPosition(device2)}">
              <span class="sr-only"></span>
              <progress class="progressBar"></progress>
            </label>
          </div>
        }
        <img [ngStyle]="{'aspect-ratio':canvasAspect2}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png"
          alt="Mobile wrapper">
        <canvas class="screen"></canvas>
        <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
      </div>
      <div class="device-header parent-device">{{device2?.model}}</div>
    </div>
    <!-- 3rd slave device -->
    <div [ngStyle]="{'display':deviceCount!=5 && deviceCount>=4?'flex':'none'}" class="mobileScreenSlaves">
      <div class="positioner">
        @if (loader3) {
          <div
            [ngStyle]="{'cursor':cursor3,'aspect-ratio':canvasAspect3,'left':loader3?'25px':'7px'}"
            class="mainDivLoader">
                    <span [ngClass]="{'bi bi-android android': device3?.platform == 'Android',
                                 'bi bi-apple iOS': device3?.platform == 'iOS'}"></span>
            <label class="loadbar" [ngStyle]="{'top': getTopPosition(device3)}">
              <span class="sr-only"></span>
              <progress class="progressBar"></progress>
            </label>
          </div>
        }
        <img [ngStyle]="{'aspect-ratio':canvasAspect3}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png"
          alt="Mobile wrapper">
        <canvas class="screen"></canvas>
        <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
      </div>
      <div class="device-header parent-device">{{device3?.model}}</div>
    </div>
  </div>
  <div [ngStyle]="{'display':deviceCount==5?'flex':'none'}" class="deviceHolder">
    <div class="col-6 col-md-6" id="upDeviceContainer">
      <!-- device1 -->
      <div class="device-card">
        <!-- <div class="device-status"></div> -->
        <div class="col-12 col-md-12 mobileScreenSlaves"
          [ngStyle]="{'height': deviceCount == 5 ? '40vh' : '60vh'}">
          <div class="positioner">
            @if (loader1) {
              <div [ngStyle]="{'cursor':cursor1,'aspect-ratio':canvasAspect1}"
                class="mainDivLoaderSlave">
                            <span [ngClass]="{
                                 'bi bi-android android': device1?.platform == 'Android',
                                 'bi bi-apple iOS': device2?.platform == 'iOS'}"></span>
                <label class="loadbar" [ngStyle]="{'top': getTopPosition(device1)}">
                  <span class="sr-only"></span>
                  <progress class="progressBarSlaves"></progress>
                </label>
              </div>
            }
            <img [ngStyle]="{'aspect-ratio':canvasAspect1}" class="wrapperSlaves"
              src="assets/Wrapper/Mobile_wrapper.png" alt="Mobile wrapper">
              <canvas class="screen"></canvas>
              <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
            </div>
          </div>
          <div class="device-header">{{device1?.model}}</div>
        </div>
        <!-- device2 -->
        <div class="device-card">

          <!-- <div class="device-status"></div> -->
          <div class="col-12 col-md-12 mobileScreenSlaves"
            [ngStyle]="{'height': deviceCount == 5 ? '40vh' : '60vh'}">
          <div class="positioner">
            @if (loader2) {
              <div [ngStyle]="{'cursor':cursor2,'aspect-ratio':canvasAspect2}"
                class="mainDivLoaderSlave">
                            <span [ngClass]="{
                                 'bi bi-android android': device2?.platform == 'Android',
                                 'bi bi-apple iOS': device2?.platform == 'iOS'}"></span>
                <label class="loadbar" [ngStyle]="{'top': getTopPosition(device2)}">
                  <span class="sr-only"></span>
                  <progress class="progressBarSlaves"></progress>
                </label>
              </div>
            }
            <img [ngStyle]="{'aspect-ratio':canvasAspect2}" class="wrapperSlaves"
              src="assets/Wrapper/Mobile_wrapper.png" alt="Mobile wrapper">
              <canvas class="screen"></canvas>
              <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
            </div>
          </div>
          <div class="device-header">{{device2?.model}}</div>
        </div>
      </div>
      <div class="col-6 col-md-6" id="downDeviceContainer">
        <!-- device3 -->
        <div class="device-card">

          <!-- <div class="device-status"></div> -->
          <div class="col-12 col-md-12 mobileScreenSlaves"
            [ngStyle]="{'height': deviceCount == 5 ? '40vh' : '60vh'}">
          <div class="positioner">
            @if (loader3) {
              <div [ngStyle]="{'cursor':cursor3,'aspect-ratio':canvasAspect3}"
                class="mainDivLoaderSlave">
                            <span [ngClass]="{
                                 'bi bi-android android': device3?.platform == 'Android',
                                 'bi bi-apple iOS': device3?.platform == 'iOS'}"></span>
                <label class="loadbar" [ngStyle]="{'top': getTopPosition(device3)}">
                  <span class="sr-only"></span>
                  <progress class="progressBarSlaves"></progress>
                </label>
              </div>
            }
            <img [ngStyle]="{'aspect-ratio':canvasAspect3}" class="wrapperSlaves"
              src="assets/Wrapper/Mobile_wrapper.png" alt="Mobile wrapper">
              <canvas class="screen"></canvas>
              <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
            </div>
          </div>
          <div class="device-header">{{device3?.model}}</div>
        </div>
        <!-- device4 -->
        <div class="device-card">

          <!-- <div class="device-status"></div> -->
          <div class="col-12 col-md-12 mobileScreenSlaves"
            [ngStyle]="{'height': deviceCount == 5 ? '40vh' : '60vh'}">
          <div class="positioner">
            @if (loader4) {
              <div [ngStyle]="{'cursor':cursor4,'aspect-ratio':canvasAspect4}"
                class="mainDivLoaderSlave">
                            <span [ngClass]="{
                                 'bi bi-android android': device4?.platform == 'Android',
                                 'bi bi-apple iOS': device4?.platform == 'iOS'}"></span>
                <label class="loadbar" [ngStyle]="{'top': getTopPosition(device4)}">
                  <span class="sr-only"></span>
                  <progress class="progressBarSlaves"></progress>
                </label>
              </div>
            }
            <img [ngStyle]="{'aspect-ratio':canvasAspect4}" class="wrapperSlaves"
              src="assets/Wrapper/Mobile_wrapper.png" alt="Mobile wrapper">
              <canvas class="screen"></canvas>
              <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off" />
            </div>
          </div>
          <div class="device-header">{{device4?.model}}</div>
        </div>
      </div>
    </div>
  </div>
  @if (aboutDevice) {
    <div [ngStyle]="{'top':device?.ios?'21.5em':'26em','left':'10em'}"
      class="aboutDevice">
    <div class="w-full max-w-xs bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg p-6 text-white">
      <div class="flex justify-between items-center mb-4">
        <h3 [ngClass]="{'bi bi-android':device?.platform=='Android','bi bi-apple':device?.platform=='iOS'}"
        class="text-xl font-bold"> {{device?.model}}</h3>
      </div>
      <div>
        <h6>{{device?.platform=='iOS'?'Apple':device?.manufacturer}}</h6>
      </div>
      <div class="space-y-3">
        <p class="text-sm opacity-80">S/N: {{device?.serial}}</p>
        <div class="progress mb-2" style="height: 7px;">
          <div class="progress" style="background-color: rgb(4 161 4); height: 7px;align-items: center;"
            [ngStyle]="{'width':device?.battery?.level+'%'}">
            <span
            style="position: relative;left: 43%;font-size: 8px;">{{device?.battery?.level+'%'}}</span>
          </div>
        </div>
        <span class="ml-2 text-sm">Battery Status: {{device?.battery?.status}}</span>
        <div class="flex items-center">
          <div class="w-full bg-white/30 rounded-full h-2.5">
            <div class="bg-green-500 h-2.5 rounded-full"></div>
          </div>
          <span class="ml-2 text-sm">Version: {{device?.version}}</span>
        </div>
        <div class="flex items-center">
          <span class="bi bi-reception-4">{{device?.network?.type}}</span>
        </div>
        <div class="flex items-center">
          <span></span>
        </div>
      </div>
    </div>
  </div>
}
<ng-template #screenshotAlert let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">OK</button>&nbsp;
    </div>
  </div>
</ng-template>